import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnippetFolderIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snippet_folder"}/>
}
